import axios from 'axios';



const API_BASE = process.env.VUE_APP_API_BASE;

function isPreview() {
    return window.location.search && window.location.search.includes('preview');
}

function getUrlParamOrNull(paramName) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has(paramName)) {
        return urlParams.get(paramName);
    }
    return null;
}

function getConfig() {
    let config = {
        params: {}
    };
    if (isPreview()) {
        config.params.preview = true;
    }
    return config;
}

async function getCollectionFormDefinition(researchStudyGroupId) {
    const config = getConfig();
    const collectionFormId = getUrlParamOrNull('collectionFormId');
    const formType = getUrlParamOrNull('formType');
    if (collectionFormId != null) {
        config.params.collectionFormId = collectionFormId;
    }
    if (formType != null) {
        config.params.formType = formType;
    }

    let response = await axios.get(API_BASE + '/api/v1/collectionForm/' + researchStudyGroupId, config);
    return response;
}

// Must match the server-side rules in ResponseValidator.java, otherwise the server rejects the whole save
const MAX_VALUE_LENGTH = 4000;

function cleanText(value) {
    if (typeof value !== 'string') {
        return value;
    }
    return value.replace(/[<>]/g, '').substring(0, MAX_VALUE_LENGTH);
}

// Only values are cleaned. Variable names come from the form definition (Element__c.Variable_Name__c),
// not the patient, and some legitimately contain < or > (e.g. "DNQ_Symptoms_started_>1_year_ago").
// Changing them breaks the match to the Element in Salesforce.
function cleanVariables(variables) {
    if (!variables) {
        return variables;
    }
    let cleaned = {};
    Object.keys(variables).forEach(name => {
        cleaned[name] = cleanText(variables[name]);
    });
    return cleaned;
}

async function saveCollectionFormResponses(collectionFormId, sessionId, status, responses, variables) {
    let responsesForServer = Object.keys(responses).map(elementId => {
        return {
            elementId: elementId,
            variableName: responses[elementId].variableName,
            value: cleanText(responses[elementId].value),
            responseTime: responses[elementId].responseTime
        }
    })

    let request = {
        sessionId: sessionId,
        responses: responsesForServer,
        status: status,
        variables: cleanVariables(variables),
        collectionFormId: collectionFormId,
        clientSaveTime: new Date().toISOString()
    };

    let response = await axios.post(API_BASE + '/api/v1/collectionForm/save', request, getConfig());

    return response.data;
}

//Site map
//fire from inside onSearch in Map
async function getSites(groupId, collectionFormId, areaCode, country, sessionId) {//"85018"
    let request = {
        researchStudyGroupId: groupId,
        collectionFormId: collectionFormId,
        postalCode: areaCode,
        country: country,
        sessionId: sessionId
    };

    let response = await axios.post(API_BASE + '/api/v1/searchsites', request, getConfig());
    return response.data;
}



export {
    getSites, getCollectionFormDefinition, saveCollectionFormResponses, API_BASE
};
